export default __webpack_public_path__ + "static/media/Smart-Governance-ON.bb2768a2.svg";